import React from 'react';
import RichText from '../RichText/RichText';

interface ArticleReferencesProps {
  references?: {
    fields?: {
      title?: string;
      links?: {
        content?: any;
      };
    };
  };
}

const ArticleReferences: React.FC<ArticleReferencesProps> = ({ references }) => {
  const title = references?.fields?.title;
  const linksContent = references?.fields?.links?.content;

  const richTextDocument = {
    fields: {
      text: {
        nodeType: 'document',
        data: {},
        content: linksContent || [],
      },
    },
  };

  return (
    <div className="w-full px-2h md:px-0 pb-4 md:pb-1 text-left">
      {title && (
        <h2 className="text-2xl leading-34 font-semi-bold text-revamp_blueText pb-1 border-b border-solid border-black">
          {title}
        </h2>
      )}
      {linksContent && (
        <RichText
          className="article-References-description"
          document={richTextDocument}
        />
      )}
    </div>
  );
};

export default ArticleReferences;